<template>
  <div class="setting1">
    <div v-if="showSetting" class="setting-enum">
      <div style="height: 22px;" class="mr-5">轮播设置：</div>
      <el-radio-group v-model="setting">
        <el-radio :label="1">手动切换</el-radio>
        <el-radio :label="30">30S切换一次</el-radio>
        <el-radio :label="60">60S切换一次</el-radio>
        <el-radio :label="120">120S切换一次</el-radio>
      </el-radio-group>
    </div>
    <div v-if="showSetting" @click="onSubmit" class="setting-btn">
      确认
    </div>
    <i @click="showSetting = !showSetting" class="el-icon-setting font-20 poi"></i>
  </div>
</template>
<script>
export default {
  name: 'setting-tab',
  data() {
    return {
      showSetting: true,
      setting: 1,
    }
  },
  methods: {
    onSubmit() {
      this.$emit('onChangeLoop', this.setting)
    }
  }
}
</script>
<style scoped>
.setting1 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 15px;
}
.setting-enum {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 5px 15px;
  border: 1px solid #fff;
  border-radius: 30px;
  margin-right: 15px;
}
.setting1::v-deep .el-radio {
  color: #fff;
}
.setting-btn {
  cursor: pointer;
  border: 1px solid #FFFFFF;
  border-radius: 16px;
  font-size: 14px;
  padding: 5px 15px;
  margin-right: 15px;

}
</style>
